import React from 'react';
import { Text } from '@goodrx/matisse';
import { prettyAddress } from 'app/lib/utils';
import { Address } from 'app/types';

interface Props {
  address?: Address;
  color?: string;
  fontSize?: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  dataQA?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressText = ({ address, color = 'greyDarker', fontSize = 14, dataQA = 'address-text' }: Props) => (
  // eslint-disable-next-line react/no-danger
  <Text
    data-qa={dataQA}
    m={0}
    fontSize={fontSize}
    fontWeight={500}
    color={color}
    style={{ whiteSpace: 'pre-line' }}
    dangerouslySetInnerHTML={{ __html: prettyAddress(address) }}
  />
);
